










































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./product_add.vue";
import Edit from "./product_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "stadium/products";

  deleteConfirmContent = "确定要删除该商品吗？";

  dispatchTypeDelete = "stadium/deleteproduct";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "商品名称", dataIndex: "name" },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "价格", scopedSlots: { customRender: "cost" } },
    { title: "天数", dataIndex: "days" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }
}
